module.exports = __webpack_public_path__ + "images/border-email-0a1ab906608aba1fc7e22e845d361dda.png";